import http from "../../http"
import {API_V1_URL} from "../../constants/other"


const PURCHASE_REQUESTS_URL = `${API_V1_URL}/purchase-requests/`

export const getPurchaseRequests = (params) => http.get(`${PURCHASE_REQUESTS_URL}`, {params})
export const updatePurchaseRequest = (purchaseRequestId, data) => http.put(`${PURCHASE_REQUESTS_URL}${purchaseRequestId}`, {data})
export const deletePurchaseRequest = (purchaseRequestId) => http.delete(`${PURCHASE_REQUESTS_URL}${purchaseRequestId}`)